export default {
      id: "triangle-usage",
      viewBox: "0 0 12 10",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#triangle-usage",
      toString: function () {
        return this.url;
      }
    }